import { render, staticRenderFns } from "./TicketConfigurator.vue?vue&type=template&id=671ef898&"
import script from "./TicketConfigurator.vue?vue&type=script&lang=ts&"
export * from "./TicketConfigurator.vue?vue&type=script&lang=ts&"
import style0 from "./TicketConfigurator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('671ef898')) {
      api.createRecord('671ef898', component.options)
    } else {
      api.reload('671ef898', component.options)
    }
    module.hot.accept("./TicketConfigurator.vue?vue&type=template&id=671ef898&", function () {
      api.rerender('671ef898', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/webshop/components/tickets/TicketConfigurator.vue"
export default component.exports